module.exports = __webpack_public_path__ + "static/playstore-mobile-ba52b4d62fd51979cb82b8639cef8094.png";